export default __webpack_public_path__ + "static/media/Car.8cf47bf2.jpg";